import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { FDContentContainer, FDStack } from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import { tidBitMetaOverrideSet } from './metaOverrideSet';
import { PM2JourneyInvestingTidbitLayout } from './tidbitLayout';

export const PM2JourneyInvestingTidbitsLayout = () => {
  const { resource } = useMetaLayoutContext();
  const tidbits = resource.attr('tidbits')?.resources()?.list() ?? [];
  return (
    <FDStack direction="column" spacing={6} paddingY={4}>
      <FDStack direction="column" spacing={4}>
        <MetaControlField attr="stepper" />
        <MetaControlField attr="title" />
        <MetaControlField attr="description" />
      </FDStack>
      <FDContentContainer
        // If there's exactly 4 tidbits, it looks more visually pleasing to see them as a 2x2 grid, so we need a smaller max width.
        // But if there's any other number of tidbits, then the lg grid is considered perfect
        maxWidth={tidbits.length === 4 ? 'md' : 'lg'}
      >
        <FDStack spacing={4} wrap justifyContent="center">
          {tidbits.map(tidbit => (
            <MetaResourceRenderer key={tidbit.id()} resource={tidbit} layout={PM2JourneyInvestingTidbitLayout} metaOverrideSet={tidBitMetaOverrideSet} />
          ))}
        </FDStack>
      </FDContentContainer>
    </FDStack>
  );
};
